import React from 'react';
import { useDnD } from '../../../context/ai-dnd.contetxt';
import { AvailableNodes, NodeType } from '../../../helper/constant';
import { renderNodeIcon } from '../../../helper/helper';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export default ({ nodes }) => {
    const [_, setType] = useDnD();

    const onDragStart = (event, nodeType) => {
        setType(nodeType);
        event.dataTransfer.effectAllowed = 'move';
    };

    const getBg = (type) => {
        switch (type) {
            case NodeType.AgentNode:
                return AvailableNodes[1].color
            case NodeType.OutputNode:
                return AvailableNodes[2].color
            case NodeType.WorkflowNode:
                return AvailableNodes[3].color
            default:
                return AvailableNodes[0].color
        }
    }


    const renderAvaialbeNodes = () => {

        return (
            AvailableNodes.map((node, key) => {
                const { type, color, name } = node;
                const tooltip = (
                    <Tooltip className='agent-tooltip'>
                        {name}
                    </Tooltip>
                );
                const hasInput = nodes.filter((node) => node.type === NodeType.InputNode).length > 0;
                if (hasInput && key === 0) {
                    return null;
                }
                return (
                    <div
                        key={`sidebar-item-${key}`}
                        onDragStart={(event) => onDragStart(event, type)}
                        draggable
                        className={`btn-dragable ${type} ${nodes.length === 0 && key !== 0 ? 'disabled' : ''}`}
                    >
                        <OverlayTrigger placement="top" overlay={tooltip}>
                            <button className='btn btn-clear btn-dnd'>
                                {renderNodeIcon(type)}
                            </button>
                        </OverlayTrigger>
                    </div>
                )
            })
        )
    }

    return (
        <aside className='sidebar'>
            <div className="description p-0 m-0 text-center fs-12">You can drag input node to below pane to continue createing workflow.</div>
            <div className='dnd-buttons'>
                {renderAvaialbeNodes()}
            </div>
        </aside>
    );
};
